/**
 * Config Reducer
 */
import { Reducer } from "redux";
import { Actions } from "root/store/Actions";
import { ICajitaConfig } from "root/store/CajitaStore";

export type IMockChangeEvent = {
  name?: string;
  // @ts-ignore
  value: unknown;
};

interface IConfigActionCreator {
  type: string;
  payload: ICajitaConfig;
  isDisablePayButton?: boolean;
}

interface ISetDisablePayButtonAction {
  type: string;
  isDisablePayButton: boolean;
}

const initialState: ICajitaConfig = {
  isInitialized: undefined,
  merchant_id: "",
  amount: "",
  currency: "USD",
  is_subscription: false,
  kushkiJS: {},
  country: "",
  disablePayButton: false,
};

const updateDisableButton: (payload: boolean) => ISetDisablePayButtonAction = (
  payload: boolean
): ISetDisablePayButtonAction => ({
  type: Actions.SET_DISABLE_PAY_BUTTON,
  isDisablePayButton: payload,
});

const ConfigReducer: Reducer<ICajitaConfig, IConfigActionCreator> = (
  state: ICajitaConfig = initialState,
  action: IConfigActionCreator
): ICajitaConfig => {
  switch (action.type) {
    case Actions.SET_CONFIG_PARAMS:
      return {
        ...state,
        ...action.payload,
        isInitialized: true,
      };
    case Actions.SET_CONFIG_INITIALIZED:
      return {
        ...state,
        disablePayButton: false,
        isInitialized: action.payload.isInitialized,
      };
    case Actions.SET_DISABLE_PAY_BUTTON:
      return {
        ...state,
        disablePayButton: action.isDisablePayButton,
      };
    default:
      return state;
  }
};

export { ConfigReducer, updateDisableButton };



// WEBPACK FOOTER //
// ./src/store/Reducer.tsx